"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./breadCrumb.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var BreadCrumbComponent = function BreadCrumbComponent(_ref) {
  var _data$slice;

  var seperator = _ref.seperator,
      data = _ref.data,
      Link = _ref.Link;

  var current_Link = _toConsumableArray(data).pop();

  return /*#__PURE__*/_react["default"].createElement(_antd.Breadcrumb, {
    separator: seperator ? seperator : ">",
    className: "iiht-ant-breadcrumb"
  }, data && (data === null || data === void 0 ? void 0 : (_data$slice = data.slice(0, -1)) === null || _data$slice === void 0 ? void 0 : _data$slice.map(function (el, index) {
    return /*#__PURE__*/_react["default"].createElement(_antd.Breadcrumb.Item, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(Link, {
      to: "".concat(el.Link)
    }, el.title));
  })), /*#__PURE__*/_react["default"].createElement(_antd.Breadcrumb.Item, null, current_Link === null || current_Link === void 0 ? void 0 : current_Link.title));
};

var _default = BreadCrumbComponent;
exports["default"] = _default;